module.exports = __webpack_public_path__ + "img/logo-new-512.a370b490.png";